import { IRootState } from '../../../store'
import { ICriticalCareOptionsState } from '../store/options.types'

export const getCriticalCareOptionsSelector = (state: IRootState): ICriticalCareOptionsState =>
  state.options.criticalCareOptions
